import { TUseFeatureFlagOptions } from '@/shared/hooks/use-feature-flag/use-feature-flag.types';
import { useReadTenantQuery } from '@/shared/redux/api/ident/ident-api';

export const useFeatureFlag = ({ skip }: TUseFeatureFlagOptions = {}) => {
  const { data, isLoading } = useReadTenantQuery(undefined, { skip });
  const featureFlags = data?.readTenant.featureFlags;

  const isFeatureFlagEnabled = (featureName: string): boolean => {
    const flag = featureFlags?.find(
      (featureFlag) => featureFlag.featureName === featureName,
    );

    return Boolean(flag?.isEnabled);
  };

  return {
    isFeatureFlagEnabled,
    isLoading,
  };
};
